import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import SurveyIcon from '../icon/surveyIcon';
import SurveyPanel from './SurveyPanel';
import './SurveyNavPopup.css';

/**
 * Navbar survey/feedback icon that opens SurveyPanel in a modal popup.
 * Modal is portaled to document.body so it is not clipped by the sticky header
 * (backdrop-filter / sticky create a containing block for position:fixed).
 */
const SurveyNavPopup = ({ user = null, page = 'main', adminMode = false }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const modal =
    open &&
    createPortal(
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Feedback survey"
        style={{
          position: 'fixed',
          inset: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 100000,
          padding: 'max(16px, env(safe-area-inset-top)) 16px 16px',
          boxSizing: 'border-box',
          overflowY: 'auto',
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            width: '100%',
            maxWidth: 720,
            maxHeight: 'min(92vh, calc(100% - 32px))',
            margin: 'auto',
            overflowY: 'auto',
            background: '#fff',
            borderRadius: 12,
            padding: 16,
            boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              marginBottom: 8,
            }}
          >
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Close feedback survey"
              style={{
                border: 'none',
                background: '#f1f5f9',
                borderRadius: 8,
                width: 36,
                height: 36,
                fontSize: 22,
                lineHeight: 1,
                cursor: 'pointer',
                color: '#334155',
              }}
            >
              &times;
            </button>
          </div>
          <SurveyPanel user={user} page={page} adminMode={adminMode} />
        </div>
      </div>,
      document.body
    );

  return (
    <>
      <button
        type="button"
        className={`survey-nav-btn${open ? ' is-open' : ''}`}
        onClick={() => setOpen(true)}
        aria-label="Open survey"
        title="Survey"
      >
        <SurveyIcon size="16px" />
        <span className="survey-nav-btn-label">Survey</span>
      </button>
      {modal}
    </>
  );
};

export default SurveyNavPopup;
